module.exports = __webpack_public_path__ + "static/img/zhu-ge-kong-ming-chen-tan-xiang.d0f5fd5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhu-ge-kong-ming-chen-tan-xiang.jpeg
// module id = VE7C
// module chunks = 1